<!--
How to call and use the component?

1) Add this to the parent:
	components: { InputTimeFormatter },

2) In the template, add this:
  <InputTimeFormatter
    :inputValue="inputValueField"
    @update:inputValue="val => inputValueField = val"
  />

3) Pay attention the the "inputValueField" is the variable you want to use as a prop and the one that will be modified
-->
<template>
	<!-- <div class="container">
		<span class="group-label">{{ inputLabel }}</span>
		<v-tooltip left>
			<template v-slot:activator="{ on, attrs }">
				<v-row class="d-flex justify-center" v-on="on" v-bind="attrs">
					<v-col cols="6">
						<v-text-field
							v-model="textValueMinutes"
							type="number"
							placeholder="MM"
							hide-details
							outlined
							:dense="dense"
							:label="$t('minutes')"
							@keypress="filterNumbersOnly">
							<template v-slot:append>
								<div style="margin: -7.5px -25px 0px 0px">
									<v-icon size="large" @click="increaseMinutes()">mdi-menu-up</v-icon>
									<v-icon size="large" @click="decreaseMinutes()">mdi-menu-down</v-icon>
								</div>
							</template>
						</v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field
							v-model="textValueSeconds"
							type="number"
							placeholder="SS"
							:label="$t('seconds')"
							hide-details
							outlined
							:dense="dense"
							@keypress="filterNumbersOnly">
							<template v-slot:append>
								<div style="margin: -7.5px -25px 0px 0px">
									<v-icon size="large" @click="increaseSeconds()">mdi-menu-up</v-icon>
									<v-icon size="large" @click="decreaseSeconds()">mdi-menu-down</v-icon>
								</div>
							</template>
						</v-text-field>
					</v-col>
				</v-row>
			</template>
			{{ $t('time-cannot-be-greater-than-2-hours') }}
		</v-tooltip>
	</div> -->
	<div :style="{ height: dense ? '66.6px' : '82.6px' }"></div>
</template>

<script>
import { formatTimeToSeconds } from '../../../utils/utilities';

export default {
	name: 'InputTimeFormatter',
	props: {
		classOverride: {
			type: String,
			default: '',
		},
		inputValue: {
			type: Number,
			default: 60,
		},
		inputIcon: {
			type: String,
			default: '',
		},
		inputLabel: {
			type: String,
			default () {
				return this.$t('time-spent');
			},
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		dense: {
			type: Boolean,
			default: true,
		},
	},
	data () {
		return {
			textValue: 0,
			textValueMinutes: '00',
			textValueSeconds: '00',
		};
	},
	watch: {
		// Watch formatted string and emit updated seconds
		textValue: {
			immediate: true,
			handler (newVal) {
				// this.$emit('update:inputValue', newVal);
				this.$emit('update:inputValue', 1);
			},
		},
		// Watch incoming prop changes and reformat time
		inputValue: {
			immediate: true,
			handler (newVal) {
				this.textValueMinutes = parseInt(newVal / 60)
					.toString()
					.padStart(2, '0');
				this.textValueSeconds = (newVal % 60).toString().padStart(2, '0');
				this.textValue = newVal; // this.formatTimeToSeconds(`${this.textValueMinutes}:${this.textValueSeconds}`);
			},
		},
		textValueMinutes (valMinutes) {
			this.textValue = this.formatTimeToSeconds(`${valMinutes}:${this.textValueSeconds}`);
		},
		textValueSeconds (valSeconds) {
			if (Number(valSeconds) > 59) {
				this.textValueSeconds = '00';
			} else {
				this.textValueSeconds = valSeconds;
			}
			this.textValue = this.formatTimeToSeconds(`${this.textValueMinutes}:${this.textValueSeconds}`);
		},
	},
	methods: {
		formatTimeToSeconds,
		increaseMinutes () {
			this.textValueMinutes = Number(this.textValueMinutes) + 1;
		},
		decreaseMinutes () {
			this.textValueMinutes = Number(this.textValueMinutes) ? Number(this.textValueMinutes) - 1 : '00';
		},
		increaseSeconds () {
			this.textValueSeconds = Number(this.textValueSeconds) + 1;
		},
		decreaseSeconds () {
			this.textValueSeconds = Number(this.textValueSeconds) ? Number(this.textValueSeconds) - 1 : '00';
		},
		filterNumbersOnly (inputEvent) {
			if (/\D/.test(inputEvent.key)) {
				inputEvent.preventDefault();
			}
			return true;
		},
	},
};
</script>
<style scoped>
.group-label {
	background-color: white !important;
	position: absolute;
	top: -13px;
	left: 10px;
	padding: 0px 5px;
}

.container {
	border: 1px solid lightgray;
	border-radius: 10px;
	position: relative;
	padding: 15px 10px 10px;
}

.small-button {
	height: 36% !important;
	margin: 0px;
	width: 10% !important;
	min-width: 10% !important;
	min-height: 10px !important;
}

.button-container {
	gap: 5px;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	margin: 0px;
	padding-left: 0px;
}
</style>
